import { defineComponent as _defineComponent } from 'vue'
import { IEvent } from '@/enitites/event'
import { BattleChip } from '@/shared/ui/chips'
import { OrganizationLabel } from '@/shared/ui/labels'
import { useBattle } from '@/enitites/battle'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventBattles',
  props: {
    event: null
  },
  setup(__props: any) {

const { getBattleCategoryName } = useBattle()



return { __sfc: true,getBattleCategoryName, BattleChip, OrganizationLabel }
}

})